import {Component, OnInit} from '@angular/core';
import {DashboardApiService} from '../../services/api/dashboard/dashboard-api.service';

@Component({
  selector: 'info-box',
  templateUrl: './info-box.component.html',
  styleUrls: ['./info-box.component.scss']
})
export class InfoBoxComponent implements OnInit {
  defaultInfoList = [
    {
      title: 'Dashboard: The new ARM entry point',
      content: 'New Summary Dashboard with single pane of glass analytics of all the main ARM aspects is now the new starting point for ARM operators.',
      Type: 'Update',
      lastUpdated: '1/07/2022',
      url: 'https://www.audiocodes.com/solutions-products/products/management-products-solutions/audiocodes-routing-manager',
      applicationType: 'ARM'
    },
    {
      title: 'New ARM UI: Improvements based on material design',
      content: 'ARM UI is now includes new improved screens layout, increased spacing between elements, magnification of elements based on material design methodology.',
      Type: 'Update',
      lastUpdated: '1/07/2022',
      url: 'https://www.audiocodes.com/solutions-products/products/management-products-solutions/audiocodes-routing-manager',
      applicationType: 'ARM'
    },
    {
      title: 'Security: Dynamic Blacklisting',
      content: 'ARM application now creates and maintains dynamic blacklist of the potential spam numbers. Operator can decide if he wish to make a blocking based on Caller or Callee numbers.',
      Type: 'Security',
      lastUpdated: '1/07/2022',
      url: 'https://www.audiocodes.com/solutions-products/products/management-products-solutions/audiocodes-routing-manager',
      applicationType: 'ARM'
    },
    {
      title: 'Routing: Increased Capacity',
      content: 'ARM now supports up to 300 Nodes, 3000 peer connections and 150 routers. Pay attention to the required specification for such High capacity setups.',
      Type: 'Routing',
      lastUpdated: '1/07/2022',
      url: 'https://www.audiocodes.com/solutions-products/products/management-products-solutions/audiocodes-routing-manager',
      applicationType: 'ARM'
    },
    {
      title: 'Appliance: now also on KVM/OpenStack platform',
      content: 'In addition to appliances on VMWare, Hyper-V, Amazon and Azure, now ARM is also supported on KVM/OpenStack platform.',
      Type: 'Update',
      lastUpdated: '1/07/2022',
      url: 'https://www.audiocodes.com/solutions-products/products/management-products-solutions/audiocodes-routing-manager',
      applicationType: 'ARM'
    }
  ];

  infoList = this.defaultInfoList;

  constructor(private dashboardApiService: DashboardApiService) { }

  ngOnInit(): void {
    this.dashboardApiService.getNewUpdates().subscribe({
      next: (data) => {
        if (data && data.dashboard) {
          this.infoList = data.dashboard;
        }
      }, error: (err) => {}
    });
  }
}
